import { render, staticRenderFns } from "./ItemDevice.vue?vue&type=template&id=0f172936"
import script from "./ItemDevice.vue?vue&type=script&lang=js"
export * from "./ItemDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports